import Vue from "vue";
import Vuex from "vuex";
import AccountService from "./services/account_service";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    modalOtpIsOpen: false,
    modalOtpIsLoading: false,
    modalCheckAccoutIsOpen: false,
    modalCheckAccoutIsLoading: false,
    captchaImageUrl: "",
    user: {}
  },
  mutations: {
    setOtpModalIsOpen(state) {
      state.modalOtpIsOpen = !state.modalOtpIsOpen;
    },
    setOtpModalIsLoading(state) {
      state.modalOtpIsLoading = !state.modalOtpIsLoading;
    },
    setCheckAccoutModalIsOpen(state) {
      state.modalCheckAccoutIsOpen = !state.modalCheckAccoutIsOpen;
    },
    setCheckAccoutIsLoading(state) {
      state.modalCheckAccoutIsLoading = !state.modalCheckAccoutIsLoading;
    },
    setCaptchaImageUrl(state, captcha) {
      state.captchaImageUrl = `data:image/png;base64,` + captcha;
    },
    setUser(state, user) {
      state.user = user;
    },
    setAccessToken(state, accessToken) {
      state.user.accessToken = accessToken;
    }
  },
  actions: {
    openOtpModal({ commit, dispatch }) {
      dispatch("getCaptcha");
      commit("setOtpModalIsOpen");
    },
    loadingOtpModal({ commit }) {
      commit("setOtpModalIsLoading");
    },
    openCheckAccountModal({ commit, dispatch }) {
      dispatch("getCaptcha");
      commit("setCheckAccoutModalIsOpen");
    },
    loadingCheckAccountModal({ commit }) {
      commit("setCheckAccoutIsLoading");
    },
    getCaptcha({ commit }) {
      AccountService.getCaptcha().then(response => {
        commit("setCaptchaImageUrl", response.data.result);
      });
    },
    saveUserInState({ commit }, user) {
      commit("setUser", user);
    },
    saveAccessTokenInUserState({ commit }, accessToken) {
      commit("setAccessToken", accessToken);
    }
  }
});
